import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Table, Checkbox, Form, Button } from "semantic-ui-react";
import ForgotPasswordStore from "../stores/ForgotPasswordStore";
import DomainNameUtils from "../../../utils/DomainNameUtils";

@observer
class ForgotPasswordDisambiguation extends Component {
  reset() {
    const { forgotPasswordStore } = this.props;
    forgotPasswordStore.isLoading = true;
    forgotPasswordStore.resetPasswordForCheckedDisambiguation().finally(() => {
      forgotPasswordStore.isLoading = false;
    });
  }

  render() {
    const { forgotPasswordStore, t } = this.props;

    return (
      <div>
        <h1>{t("login:weFoundMultipleMatchesEmail")}</h1>
        <p>
          {t("login:emailAddressDots")} <strong>{forgotPasswordStore.usernameOrEmail}</strong>
        </p>
        <p>
          {t("login:pleaseCheckAllAccountsResetPassword")} <strong>{t("login:reset")}</strong>.
        </p>
        <Form loading={forgotPasswordStore.isLoading}>
          <Table compact celled unstackable className="forgot-password-disamb-table small">
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell />
                {!DomainNameUtils.isCustomDomain() && <Table.HeaderCell>{t("login:company")}</Table.HeaderCell>}
                <Table.HeaderCell>{t("login:accountType")}</Table.HeaderCell>
                <Table.HeaderCell>{t("login:accountName")}</Table.HeaderCell>
                <Table.HeaderCell>{t("login:accountCompany")}</Table.HeaderCell>
                <Table.HeaderCell>{t("login:message")}</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {forgotPasswordStore.passwordResetDisambiguation.map((passwordResetDisambiguation, index) => (
                <Table.Row
                  negative={passwordResetDisambiguation.isResetPasswordError}
                  positive={passwordResetDisambiguation.isResetPasswordSuccess}
                  key={passwordResetDisambiguation.username}
                >
                  <Table.Cell>
                    <Checkbox
                      checked={passwordResetDisambiguation.checked}
                      onChange={(data, value) => {
                        forgotPasswordStore.passwordResetDisambiguation[index].checked = value.checked;
                      }}
                    />
                  </Table.Cell>
                  {!DomainNameUtils.isCustomDomain() && <Table.Cell>{passwordResetDisambiguation.provider}</Table.Cell>}
                  <Table.Cell>{passwordResetDisambiguation.userClass}</Table.Cell>
                  <Table.Cell>{passwordResetDisambiguation.name}</Table.Cell>
                  <Table.Cell>{passwordResetDisambiguation.company}</Table.Cell>
                  <Table.Cell>{passwordResetDisambiguation.resetPasswordMessage}</Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
          <Button
            primary
            fluid
            className="forgot-password-btn"
            type="submit"
            disabled={!forgotPasswordStore.canResetDisambiguationPassword}
            onClick={() => {
              this.reset();
            }}
          >
            {t("login:reset")}
          </Button>
          <p className="forgot-password-back-to-login">
            <Link to="/">{t("login:backToLogin")}</Link>
          </p>
        </Form>
      </div>
    );
  }
}

ForgotPasswordDisambiguation.propTypes = {
  forgotPasswordStore: PropTypes.instanceOf(ForgotPasswordStore).isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(ForgotPasswordDisambiguation);
